import Vue from 'vue';
import Modal from './Modal.vue';


const initModal = {
    init() {
        if (document.getElementById('app')) {
            new Vue({
                el: '#app',
                data: {
                    showModal: false,
                    title: null,
                    text: null,
                },

                methods: {
                    fetchData(e) {
                        const localJSON = JSON.parse(e.target.dataset.content);
                        this.title = localJSON.title;
                        this.text = localJSON.text;
                        this.showModal = true;
                    }
                },

                components: {
                    'Modal': Modal,
                },
            });
        }
    },

};

export default initModal;

